import { config } from './config/slider'

$('.article-list-slider').slick({
    ...config,
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><img src="/assets/img/icons/icon_dark_arrowprev@3x.svg" alt="Previous"/></button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><img src="/assets/img/icons/icon_dark_arrownext@3x.svg" alt="Next"/></button>',
});